import {GET_ACTIVE_LOT_INFO} from './types';

export const getActiveLotInfo = id => ({
  event: GET_ACTIVE_LOT_INFO,
  link: `/api/info/active-lot/${id}`,
});